import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import VendorSpinStartState from "../../../vendor_core/src/states/VendorSpinStartState";

export default class BURVendorSpinStartState extends VendorSpinStartState {
    public async enter() {
        if (!SpinModel.isInFreespins()) {
            SoundController.playSound(SoundVars.BUTTON_SPIN, false);
        }

        super.enter();
    }
}
